import React, { useState } from 'react';
import SideNav from '../SideNav/SideNav';
import GameVotesTable from './GameVotesTable';

const GameVotes = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-[#020817] text-white">
      {/* Navigation */}
      <SideNav 
        isMobileMenuOpen={isMobileMenuOpen} 
        setIsMobileMenuOpen={setIsMobileMenuOpen} 
      />

      {/* Game Votes Content */}
      <div className="md:ml-[var(--sidenav-width)] md:transition-[margin-left] md:duration-200 md:ease-out pt-3 md:pt-6 pb-20 md:pb-0">
        <div className="px-3 md:px-6 pb-6"> 
          {/* Game Votes Table */}
          <GameVotesTable />
        </div>
      </div>
    </div>
  );
};

export default GameVotes;